(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["measure-quote-form"] && !Shopify.designMode) return;
  try {
    function trackMeasureQuoteLead() {
    const successMessage = document.querySelector(
      '[data-measure-quote] h2.form-status-list.form__message'
    );

    if (!successMessage) return;

    const trackingKey = 'decora_measure_quote_lead_sent';

    try {
      if (sessionStorage.getItem(trackingKey) === '1') return;
    } catch (error) {
      // Continue with event tracking if session storage is unavailable.
    }

    if (typeof window.gtag !== 'function') {
      console.warn('Decora: Google tag is not available yet.');
      return;
    }

    window.gtag('event', 'generate_lead', {
      method: 'measure_quote_form'
    });

    try {
      sessionStorage.setItem(trackingKey, '1');
    } catch (error) {
      console.warn('Decora: Could not save tracking session.');
    }

    console.log('Decora: Measure & Quote lead event sent.');
  }

  function normaliseInterest(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function interestTokenKey(value) {
    return normaliseInterest(value).split(' ').filter(Boolean).sort().join(' ');
  }

  const interestAliases = {
    'sunscreen roller blinds': 'roller blinds screen',
    'screen roller blinds': 'roller blinds screen',
  };

  function interestOptions(interest) {
    return Array.from(interest.options).filter((option) => option.value);
  }

  function findInterestOption(interest, productName) {
    const wanted = normaliseInterest(productName);
    if (!wanted) return null;

    const options = interestOptions(interest);
    const exact = options.find((option) => normaliseInterest(option.value) === wanted);
    if (exact) return exact;

    const aliased = interestAliases[wanted];
    if (aliased) {
      const aliasMatch = options.find((option) => {
        return normaliseInterest(option.value) === aliased || interestTokenKey(option.value) === interestTokenKey(aliased);
      });
      if (aliasMatch) return aliasMatch;
    }

    const wantedTokens = interestTokenKey(wanted);
    const tokenMatches = options.filter((option) => interestTokenKey(option.value) === wantedTokens);
    if (tokenMatches.length === 1) return tokenMatches[0];

    return null;
  }

  function selectInterest(interest, productName) {
    const label = productName.trim();
    let match = findInterestOption(interest, label);

    if (!match) {
      match = new Option(label, label);
      interest.add(match);
    }

    interestOptions(interest).forEach((option) => {
      option.selected = false;
    });
    match.selected = true;
    interest.value = match.value;
  }

  function syncMeasureQuote(root) {
    const params = new URLSearchParams(window.location.search);
    const productName = params.get('product') || params.get('interest');
    const productInput = root.querySelector('[data-measure-quote-product]');
    const interest = root.querySelector('[data-measure-quote-interest]');
    if (!productName || !productName.trim()) return;

    const label = productName.trim();
    if (productInput) {
      productInput.value = label;
      productInput.dataset.synced = 'true';
    }
    if (interest) selectInterest(interest, label);
  }

  function selectedCountry(country) {
    return country.options[country.selectedIndex];
  }

  function formatMeasureQuotePhone(root) {
    const country = root.querySelector('[data-measure-quote-country]');
    const phone = root.querySelector('[data-measure-quote-phone]');
    const phoneValue = root.querySelector('[data-measure-quote-phone-value]');
    const countryValue = root.querySelector('[data-measure-quote-country-value]');
    if (!country || !phone || !phoneValue) return;

    const option = selectedCountry(country);
    const dial = option && option.dataset.dial ? option.dataset.dial : '+61';
    const dropTrunkZero = option && option.dataset.trunk === '0';
    if (countryValue) countryValue.value = option && option.dataset.country ? option.dataset.country : 'Australia';

    const compact = phone.value.replace(/[\s().-]/g, '');
    if (!compact) {
      phoneValue.value = '';
      return;
    }
    if (compact.charAt(0) === '+') {
      phoneValue.value = compact;
      const match = Array.from(country.options)
        .filter((item) => item.dataset.dial && compact.indexOf(item.dataset.dial) === 0)
        .sort((left, right) => right.dataset.dial.length - left.dataset.dial.length)[0];
      if (match && countryValue) countryValue.value = match.dataset.country;
      return;
    }
    if (compact.indexOf('00') === 0) {
      phoneValue.value = '+' + compact.slice(2);
      return;
    }

    let national = compact;
    if (dropTrunkZero && national.charAt(0) === '0') national = national.slice(1);
    const dialDigits = dial.replace('+', '');
    if (national.indexOf(dialDigits) === 0) {
      phoneValue.value = '+' + national;
      return;
    }
    phoneValue.value = dial + national;
  }

  function initMeasureQuote() {
    trackMeasureQuoteLead();
    document.querySelectorAll('[data-measure-quote]').forEach((root) => {
      const productInput = root.querySelector('[data-measure-quote-product]');
      const interest = root.querySelector('[data-measure-quote-interest]');
      const form = root.querySelector('form');
      const country = root.querySelector('[data-measure-quote-country]');

      syncMeasureQuote(root);

      if (country) {
        const phone = root.querySelector('[data-measure-quote-phone]');
        const existing = phone ? phone.value.replace(/[\s().-]/g, '') : '';
        if (existing.charAt(0) === '+') {
          const match = Array.from(country.options)
            .filter((option) => option.dataset.dial && existing.indexOf(option.dataset.dial) === 0)
            .sort((left, right) => right.dataset.dial.length - left.dataset.dial.length)[0];
          if (match) {
            match.selected = true;
            country.dataset.changed = 'true';
          }
        } else {
          const australia = Array.from(country.options).find((option) => option.value === 'AU');
          if (australia) australia.selected = true;
        }
        country.addEventListener('change', () => {
          country.dataset.changed = 'true';
          formatMeasureQuotePhone(root);
        });
      }

      formatMeasureQuotePhone(root);

      if (form) {
        form.addEventListener('submit', () => {
          formatMeasureQuotePhone(root);
        });
      }

      if (interest && productInput) {
        interest.addEventListener('change', () => {
          const selected = interest.options[interest.selectedIndex];
          if (!selected || !selected.value) return;
          if (!productInput.value.trim() || productInput.dataset.synced === 'true') {
            productInput.value = selected.text;
            productInput.dataset.synced = 'true';
          }
        });

        productInput.addEventListener('input', () => {
          productInput.dataset.synced = 'false';
          const match = findInterestOption(interest, productInput.value);
          if (match) {
            interest.value = match.value;
            match.selected = true;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeasureQuote);
  } else {
    initMeasureQuote();
  }
  } catch(e) { console.error(e); }
})();

})();
